import { format } from "date-fns/esm";

export default function(value: string) {
    if (value) {
        return format(new Date(value), "MMM do, yyyy");
    }
    return "-";
}
